__turbopack_context__.v({
  "body": "card-module-scss-module__GxdQzq__body",
  "divider": "card-module-scss-module__GxdQzq__divider",
  "header": "card-module-scss-module__GxdQzq__header",
  "headerRow": "card-module-scss-module__GxdQzq__headerRow",
  "headerRowOverview": "card-module-scss-module__GxdQzq__headerRowOverview",
  "root": "card-module-scss-module__GxdQzq__root",
  "rootHoverBorder": "card-module-scss-module__GxdQzq__rootHoverBorder",
  "title": "card-module-scss-module__GxdQzq__title",
  "titleAccent": "card-module-scss-module__GxdQzq__titleAccent",
  "titleGroup": "card-module-scss-module__GxdQzq__titleGroup",
  "titleIcon": "card-module-scss-module__GxdQzq__titleIcon",
  "titleNeutral": "card-module-scss-module__GxdQzq__titleNeutral",
  "titleRight": "card-module-scss-module__GxdQzq__titleRight",
});
